import { fetcher } from 'src/config/request';
import { UnleashEndpoints } from './endpoints';
export const UnleashService = {
    async getStatus(name, unleashId) {
        return (await fetcher.get(UnleashEndpoints.getStatus(name), {
            params: { unleashId },
            headers: {
                Authorization: undefined
            }
        })).data;
    }
};
